// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qTE8","textarea":"styles_textarea__3x15P"};